import {Pipe, PipeTransform} from "@angular/core";
import {LoginService} from "../../login/login.service";
import {UsuariosModel} from "../../usuarios/usuarios.model";
//import * as moment from 'moment';
declare let moment: any;

@Pipe({
  name: 'dataHora'
})
export class DataHoraPipe implements PipeTransform {

  private userInfo = new UsuariosModel;

  constructor(private loginService: LoginService) {

    loginService.getUserInfo().subscribe(
      res => {
        this.userInfo = res;
      },
      error => {
        this.loginService.trataErro(error.json());
      });

  }

  transform(value, tipo:any) {

    let retorno = '';

    if(!value){
      return '';
    }

    if(tipo == 'dataHora'){

      retorno = moment(value).format(this.userInfo.date_format+' '+this.userInfo.time_format);

    }else if(tipo == 'hora'){

      retorno = moment(value).format(this.userInfo.time_format);

    }else{ // data

      retorno = moment(value).format(this.userInfo.date_format);

    }

    return retorno;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/data-hora.pipe.ts